/** Opt-in: embroidery options stay collapsed and disabled until the buyer ticks "laat personaliseren". */
class EmbroideryOptOut extends HTMLElement {
  #ac;
  #controls = [];
  #content = [];

  connectedCallback() {
    this.#ac = new AbortController();
    // Defer until the complete fieldset has parsed (including content after this control).
    queueMicrotask(() => {
      if (!this.isConnected) return;
      const group = this.closest('fieldset');
      const host = this.closest('[data-product-form]');
      const toggle = this.querySelector('[data-embroidery-skip]');
      const property = this.querySelector('[data-skip-property]');
      if (!group || !toggle || !property) return;
      this.#controls = [...group.querySelectorAll('input, select, textarea, button')]
        .filter((el) => !this.contains(el) && !el.closest('[data-embroidery-keep]'))
        .map((el) => ({ el, disabled: el.disabled }));
      this.#content = [...group.children]
        .filter((el) => el !== this && !el.hasAttribute('data-embroidery-keep') && el.tagName !== 'LEGEND' && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE')
        .map((el) => ({ el, hidden: el.hidden }));
      const apply = () => {
        const skip = !toggle.checked;
        if (host) host.dataset.skipEmbroidery = String(skip);
        for (const { el, disabled } of this.#controls) el.disabled = skip || disabled;
        for (const { el, hidden } of this.#content) el.hidden = skip || hidden;
        property.disabled = !skip;
        if (skip) {
          group.querySelectorAll('[data-step-error]').forEach((el) => el.remove());
          group.querySelectorAll('[aria-invalid="true"]').forEach((el) => el.removeAttribute('aria-invalid'));
          for (const el of [group, ...group.querySelectorAll('[style]')]) {
            el.style.removeProperty('outline');
            el.style.removeProperty('outline-offset');
          }
          const error = this.closest('form')?.querySelector('[data-add-to-cart-error]');
          if (error?.textContent.startsWith('Je bent een stap vergeten')) {
            error.textContent = '';
            error.hidden = true;
          }
        }
        // Update the sticky bar without running browser validation.
        toggle.dispatchEvent(new Event('input', { bubbles: true }));
      };
      // Keep the buyer's choice across variant swaps; otherwise start open where the block asks for it (sweaters).
      const saved = host?.dataset.skipEmbroidery;
      toggle.checked = saved ? saved === 'false' : this.hasAttribute('data-open');
      toggle.addEventListener('change', apply, { signal: this.#ac.signal });
      this.hidden = false;
      // Coming from the verlanglijstje with "Met personalisatie": open the options straight away.
      if (new URLSearchParams(location.search).get('personaliseer') === '1') toggle.checked = true;
      apply();
    });
  }

  disconnectedCallback() { this.#ac?.abort(); }
}
if (!customElements.get('s-embroidery-opt-out')) {
  customElements.define('s-embroidery-opt-out', EmbroideryOptOut);
}
